<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem, filters }"
    custom-export-url="/transports/export/"
  >
    <template v-slot:form="{ editedItem, error }">
      <transport-form v-bind="{ editedItem, error, modelFk }"></transport-form>
    </template>

    <template v-slot:item.start_date="{ item }">
      {{ formatDate(item.start_date) }}
    </template>

    <template v-slot:item.warnings="{ item }">
      <v-icon v-if="item.warnings.length > 0">
        fa fa-exclamation-triangle
      </v-icon>
    </template>

  </generic-update-list>
</template>

<script>
import models from "@/models"
import TransportForm from "@/components/TransportForm"

export default {
  components: { TransportForm },
  data() {
    return {
      modelHeaders: [
        // { text: "Descrizione sintetica", value: "short_description" },
        { text: "Artisti", value: "transport__people" },
        { text: "Autisti", value: "transport__drivers" },
        { text: "Mezzo", value: "kind_verbose" },
        { text: "Data", value: "start_date" },
        { text: "Alert", value: "warnings" },
      ],
      model: models.Transport,
      filters: [
        { name: "people", model: models.ShowPerson, text: "person__name", label: "Artisti" },
        { name: "drivers", model: models.ShowPerson, text: "person__name", label: "Autisti" },
        {
          name: "kind",
          label: "Mezzo",
          values: [
            { id: 1, name: "Auto" },
            { id: 2, name: "Treno" },
            { id: 3, name: "Aereo" },
            { id: 4, name: "Altro" },
          ],
        },
      ],
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      short_description: "",
      kind: 1,
      start_date: "",
      start_place: "",
      end_date: "",
      end_place: "",
      drivers: [],
      people: [],
      status: 1,
      cost: 0,
      is_ocm_pickup: false,
      is_cumbersone: false,
      notes: "",
    }),
    formatDate(date) {
      const parsedDate = new Date(date)
      const day = String(parsedDate.getDate()).padStart(2, '0')
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
      const year = parsedDate.getFullYear()
      const hours = String(parsedDate.getHours()).padStart(2, '0')
      const minutes = String(parsedDate.getMinutes()).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}`
    }
  },
}
</script>
